import { TimeslotsByDoctor } from 'entities/timeslots';
import { Doctor } from 'features/doctors/store/types';
import { FC, memo, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { ITimeslot } from 'entities/timeslots/store/types';
import styles from './styles.module.scss';
import { pluralize } from 'shared/lib/writing';
import { Link, useNavigate } from 'react-router-dom';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';

interface DoctorProps {
	doctor: Doctor;
  showLink?: boolean
  showDetails?: boolean
}

const arePropsEqual = (
	prevProps: {
		doctorId: number;
		selectedSlot: ITimeslot | null;
		selectDoctorSlot: (slot: ITimeslot) => void;
	},
	nextProps: {
		doctorId: number;
		selectedSlot: ITimeslot | null;
		selectDoctorSlot: (slot: ITimeslot) => void;
	},
) => {
	return (
		prevProps.doctorId === nextProps.doctorId &&
		prevProps.selectedSlot === nextProps.selectedSlot &&
		prevProps.selectDoctorSlot === nextProps.selectDoctorSlot
	);
};

memo(TimeslotsByDoctor, arePropsEqual);

export const DoctorCardInfo: FC<DoctorProps> = observer(
	({ doctor, showLink, showDetails }) => {
		const [doctorPhoto, setPhoto] = useState(doctor.photo);

    const navigate = useNavigate();

		// useEffect(() => {
		// 	console.log({...timeslot})
		// }, [timeslot]);

		const experienceMemo = useMemo(() => {
			let experience = '';

			if (doctor.specializations.length)
				experience += doctor.specializations
					.map(spec => spec.name)
					.join(', ');

			if (doctor.medical_experience_years)
				experience += ` • Общий стаж ${doctor.medical_experience_years} ${pluralize(doctor.medical_experience_years, 'год', 'года', 'лет' )}`;

			if (doctor.category) experience += ' • ' + doctor.category;

			if (doctor.degree) experience += ' • ' + doctor.degree;

			return <p className={styles['doctor-card__info']}>{experience}</p>;
		}, [
			doctor.specializations,
			doctor.medical_experience_years,
			doctor.category,
			doctor.degree,
		]);

		return (
			<div className={`${styles['doctor-card']} ${styles['doctor-card_noshadow']}`}>
				<div>
          {showLink ? 
          <Link to={`/doctors-selection/${doctor.id}/full`} className={styles['doctor-card__name']}>
						{doctor.full_name}
          </Link> :
					<p className={styles['doctor-card__name']}>
						{doctor.full_name}
					</p>
          }
				</div>
				<div className={styles['doctor-card__header']}>
					<div>
						<div className={styles['doctor-card__info']}>
							{experienceMemo}
						</div>
					</div>
					{doctorPhoto && (
						<img
							className={styles['doctor-card__photo']}
							src={doctorPhoto}
							alt={doctor.full_name}
							onError={() => {
								setPhoto('');
							}}
						/>
					)}
				</div>
        {showDetails && 
				<div className={styles['doctor-card__details']}>
          {doctor.services?.length > 0 && doctor.services.map(service => {
            const opts: Intl.NumberFormatOptions = { style: "currency", currency: "RUB", maximumFractionDigits: 2 }
            const priceNum = service.service.price_value === 'number' ? service.service.price_value : Number(service.service.price_value);
            const price = priceNum.toLocaleString('ru-RU', opts).replace(',00', '');
            return (
              <div className={styles['doctor-card__consultation']} key={service.service.id}>
                <p className={styles['doctor-card__consultation-name']}>
                  {service.service.name}
                </p>
                <span>{price}</span>
              </div>
            )
          })}
				</div>
        }
        {showLink && 
        <ButtonContained
          variant={'primary'}
          onClick={() => navigate(`/doctors-selection/${doctor.id}/full`)}
        >
          Записаться
        </ButtonContained>
        }
			</div>
		);
	},
);
